import { memo } from "react";

import { Skeleton } from "@/components/ui/skeleton";

const ChatListSkeletonInner = (): React.ReactElement => (
  <div className="space-y-2" data-testid="chat-list-loading-state">
    {Array.from({ length: 5 }).map((_, rowIndex) => (
      <Skeleton
        key={`chat-skeleton-${rowIndex + 1}`}
        className="h-10 w-full rounded-md"
      />
    ))}
  </div>
);

export const ChatListSkeleton = memo(ChatListSkeletonInner);
